module.exports = __webpack_public_path__ + "img/xiaoman8.2099b43c.png";